<h2 class="h3">{{ title() }}</h2>

<div class="faq-grid" [ngClass]="isGrid$() ? 'masonry' : 'row gutter-y-4'">
  @for (cat of getKeys(group()); track cat; let i = $index) {
    <div class="faq-grid__item" [ngClass]="isGrid$() ? '' : 'col-md-12'">
      <h3 class="h6 fs-body-md text-primary mb-3 fw-semi ps-1">{{ cat }}</h3>

      <mat-accordion>
        @for (faq of group()[cat]; track $index; let i = $index) {
          <mat-expansion-panel
            (opened)="openItem(cat, i)"
            (closed)="openPanels()[cat] === i ? (openPanels()[cat] = null) : null"
            [ngClass]="{
              'mat-before-expanded': openPanels()[cat] !== null && openPanels()[cat] - 1 === i,
              'mat-after-expanded': openPanels()[cat] !== null && openPanels()[cat] + 1 === i,
            }"
          >
            <mat-expansion-panel-header>
              <mat-panel-title class="fs-body-md fw-normal">{{ faq.question }}</mat-panel-title>
            </mat-expansion-panel-header>

            @if (faq.answer) {
              <div
                class="markdown-content"
                fstrDynamicContent
                [innerHTML]="faq.answer | resizeHtmlImages | stripEmbed: cookiePreferences() | safe"
              ></div>
            }
          </mat-expansion-panel>
        }
      </mat-accordion>
    </div>
  }
</div>
